import { oz } from '@weft/utils';

export const UNLIMITED_DURATION = -1;

export const UnlimitedDurationSchema = oz.literal(UNLIMITED_DURATION).openapi('UnlimitedDuration');

export type UnlimitedDuration = oz.infer<typeof UnlimitedDurationSchema>;